// TinyGesture - Ultra-lightweight touch gesture recognizer
export class TinyGesture {
  constructor(element, options = {}) {
    this.element = element;
    this.options = Object.assign(
      {
        threshold: (type, self) =>
          Math.max(25, Math.floor(0.15 * (type === 'x' ? self.element.clientWidth : self.element.clientHeight))),
        longPressTime: 500,
        passive: true,
        mouseSupport: true,
      },
      options
    );

    this.touchStartX = 0;
    this.touchStartY = 0;
    this.touchEndX = 0;
    this.touchEndY = 0;
    this.longPressTimer = null;

    this.handlers = {
      swipeleft: [],
      swiperight: [],
      swipeup: [],
      swipedown: [],
      longpress: [],
      tap: [],
    };

    this.init();
  }

  on(type, fn) {
    if (this.handlers[type]) {
      this.handlers[type].push(fn);
    }
  }

  emit(type, event) {
    if (this.handlers[type]) {
      this.handlers[type].forEach((fn) => fn(event));
    }
  }

  init() {
    const opts = { passive: this.options.passive };

    const onStart = (e) => {
      const touch = e.touches ? e.touches[0] : e;
      this.touchStartX = touch.clientX;
      this.touchStartY = touch.clientY;
      this.touchEndX = touch.clientX;
      this.touchEndY = touch.clientY;

      clearTimeout(this.longPressTimer);
      this.longPressTimer = setTimeout(() => {
        this.emit('longpress', e);
      }, this.options.longPressTime);
    };

    const onMove = (e) => {
      const touch = e.touches ? e.touches[0] : e;
      this.touchEndX = touch.clientX;
      this.touchEndY = touch.clientY;

      const deltaX = Math.abs(this.touchEndX - this.touchStartX);
      const deltaY = Math.abs(this.touchEndY - this.touchStartY);

      if (deltaX > 10 || deltaY > 10) {
        clearTimeout(this.longPressTimer);
      }
    };

    const onEnd = (e) => {
      clearTimeout(this.longPressTimer);
      const deltaX = this.touchEndX - this.touchStartX;
      const deltaY = this.touchEndY - this.touchStartY;
      const absX = Math.abs(deltaX);
      const absY = Math.abs(deltaY);

      const thresholdX =
        typeof this.options.threshold === 'function' ? this.options.threshold('x', this) : this.options.threshold;

      if (absX > thresholdX && absX > absY) {
        if (deltaX < 0) {
          this.emit('swipeleft', e);
        } else {
          this.emit('swiperight', e);
        }
      }
    };

    const onCancel = () => {
      clearTimeout(this.longPressTimer);
    };

    this.element.addEventListener('touchstart', onStart, opts);
    this.element.addEventListener('touchmove', onMove, opts);
    this.element.addEventListener('touchend', onEnd, opts);
    this.element.addEventListener('touchcancel', onCancel, opts);

    if (this.options.mouseSupport) {
      let isMouseDown = false;
      let swiped = false;
      this.element.addEventListener('mousedown', (e) => {
        isMouseDown = true;
        swiped = false;
        onStart(e);
      });
      this.element.addEventListener('mousemove', (e) => {
        if (isMouseDown) onMove(e);
      });
      this.element.addEventListener('mouseup', (e) => {
        if (isMouseDown) {
          isMouseDown = false;
          const deltaX = Math.abs(this.touchEndX - this.touchStartX);
          const deltaY = Math.abs(this.touchEndY - this.touchStartY);
          if (deltaX > 15 || deltaY > 15) {
            swiped = true;
          }
          onEnd(e);
        }
      });
      this.element.addEventListener('click', (e) => {
        if (swiped) {
          e.preventDefault();
          e.stopPropagation();
          swiped = false;
        }
      }, true);
    }
  }
}
